import './policy.scss';
import { Footer } from '../../components/Footer';

function UseAfterSalesPolicy() {
  return (
    <>
      <div
        className="policy-content"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/image/policy-bg.png)` }}
      >
        <div style={{ width: '100%', paddingTop: 12 }}>
          <span style={{ color: '#621ECE', paddingLeft: 12, fontSize: 16 }}>
            《桃高乐使用协议》2026年4月1日生效版本
          </span>
        </div>
        <p
          style={{
            color: '#191430',
            whiteSpace: 'pre-line',
            paddingInline: 12,
            paddingBottom: 12,
            marginInline: 12,
            marginBottom: 12,
            fontSize: 13,
            backgroundColor: 'rgba(255,255,255,0.7)',
            borderRadius: 12,
            border: '1px solid #ffffff',
          }}
        >
          <p style={{ color: '#621ECE', textAlign: 'center', fontSize: 16 }}>【特别提示】</p>
          {`《桃高乐使用协议》(简称为“本协议”) 是您与桃高乐之间关于桃高乐平台中提供的服务的法律协议。
在此特别提醒，请您在使用桃高乐服务前阅读并充分理解本协议，特别是免除或者限制责任的相关条款，双方确认前述条款不属于《中华人民共和国民法典》第四百九十七条规定的“不合理地免除或者减轻其责任、加重对方责任、限制、排除对方主要权利”条款，您认可其合法性及有效性。
桃高乐可能会根据桃高乐整体规划等，对本协议进行修改或变更，修改或变更的内容将于相关页面提前七日进行公告。若您不同意桃高乐或本协议的前述修改或变更，您可停止使用桃高乐服务。您使用桃高乐服务即视为您接收并同意本协议所有条款，包括但不限于前述修改及变更，请您在勾选同意本协议前道慎阅读并理解相关内容，如您勾选同意即视为您自此发生的交易均受该协议约束，包括但不限于前述修改及变更。如您违反本协议约定，桃高乐有权随时中止或停止该服务。
如果您因年龄（未满18周岁）、智力等因素而不具有完全民事行为能力，请在法定监护人的陪同下阅读本协议。 本协议是基于 《桃高乐用户使用协议》、《桃高乐服务协议》以及桃高乐相关协议规范（统称为“桃高乐服务条款”）制定，与其是不可分割的。同时，桃高乐不时发布的关于桃高乐的相关协议、服务规则、公告、活动规则等各类规则也是本协议的一部分，您在使用桃高乐服务的同时应遵守本协议。
适用范围：本协议适用于通过销售的所有商品和服务（以下统称“商品”）。
特别提示：由于您使用的软件版本，设备、操作系统等不同以及第三方原因可能导致您实际可使用的具体服务有差别，由此可能给您带来的不便，您表示理解，同时并不会因此向桃高乐及其关联公司提出任何主张或追究桃高乐及其关联公司任何责任。
一、缺货/延期:
(1）由于市场变化、供应商生产计划变化、系统问题、不可抗力等因素影响，您所提交的订单信息中的商品可能存在缺货情形。在此情形下，桃高乐将以有效方式（包括但不限于在桃高乐发布公告，发送邮件，向您提供的联系电话发送手机短信，向您的桃高乐账号发送消息或系统通知等方式）通知您并提供解决方案（包括但不限于取消订单、换货、调货等方式）。请您在未收到商品之前留意通知；
(2）桃高乐将在一周内以短信或电话的方式向您发送两次通知。请您在收到通知后14天内主动联系在线客服，桃高乐提供取消订单并全额退款、换货或调货等解决方案供您选择。如您在收到通知后30日内未作出选择，桃高乐将取消订单，为您办理退款处理，由此给您带来的不便敬请谅解；
(3）缺货商品是否补货不再另行通知，如您对此赏品感兴趣，请您随时关注；
(4）请您知悉桃高乐中的预售商品，客服给出的发货时间为参考时间，该参考时间可能因库存状况、送货时间、送货地点等客观因素存在误差，具体发货时间以商品实际发货时间为准；
(5）请您同样知悉预售类商品的实际发货时间会因受制作周期、物流周期、质检返工、不可抗力等诸多因素影响时效存在误差，导致预售类商品的实际发货时间可能延迟，您对上述情形表示同意及理解。
二、使用说明：
(1) 单次提交发货申请的商品超过5件可享包邮(香港、澳门、台湾、青海、内蒙古、西藏、新疆等偏远地区需联系客服补差价)，不足5件的，需支付12元邮费(香港、澳门、台湾、青海、内蒙古、西藏、新疆等偏远地区需联系客服补差价)或者选择到付等方式，收件地址在此之外的区域请勿下单。桃高乐商品默认中通或顺丰；
(2) 签收商品时，请您亲自检查包装情况，在快递员面前验货，并在确认无误后签收；
(3) 桃高乐包含一个或多个不同系列的商品，每个系列中一整盒对应的初始商品数量可能因种类不同而不同。桃高乐商品可能存在拆盒售卖，由平台二次包装的情况，请您谨慎考虑后购买；
(4) 部分预售商品出版后可能会先通过跨境方式至境内进行发货，大约需要45天时间，无需您提供个人信息，平台会在商品到达境内后第一时间通知您，届时可在赏柜进行发货操作；
(5）桃高乐商品随机出现，并设有防沉迷机制，触发后将限制消费，具体以页面出现的提示为准，请您理性消费。
三、法律适用与争议解决:
(1) 桃高乐不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响桃高乐在将来行使该权利；
(2）本协议的订立、效力、解释、履行、修改和中止以及争议的解决适用中华人民共和国法律。因解释和履行本协议而发生的任何争议，应尽量通过友好协商的方式加以解決。

`}
<strong  >如果在一方向其他方发出要求协商解决的书面通知后30天之内争议仍然得不到解决，则争议各方一致同意提交中国安徽蚌埠市仲裁委员会解决。仲裁裁决是终局的，对双方均有约束力。</strong>
 {`

 四、其他：
(1) 除非另有证明，储存在桃高乐服务器上的数据是您使用桃高乐服务的唯一有效证据；
(2) 若您存在以下不正当行为，一经发现桃高乐有权采用包括但不限于暂停发货、取消订单、拦截已发货的订单，限制账户权限等措施：
1.用户利用技术手段或其他方式在桃高乐套取赏品、运费或其他利益；
2.桃高乐认定的其他不正当行为。
您确认并同意，前述措施将同样适用于您的关联账号。

`}
 

 <p  style={{ fontWeight: 'bold' }}> 五、免责事由： </p>

<p  style={{ fontWeight: 'bold' }}>(1）您知悉并同意，桃高乐不因下述任一情况可能导致的任何损害赔偿承担责任，包括但不限于财产、收益、数据资料等方面的损失或其他无形损失：</p>

<p  style={{ fontWeight: 'bold' }}>1.因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力值因素导致系统或服务不能正常运作；</p>

<p  style={{ fontWeight: 'bold' }}>2.由于黑客攻击、电信部门技术调整或故障、系统维护等原因而造成的服务中断或者延迟；</p>

<p  style={{ fontWeight: 'bold' }}>3.由于政府命令、法律法规的变更、司法机关及行政机关的命令、裁定等原因而导致的系统服务中断、终止或延迟；</p>

<p  style={{ fontWeight: 'bold' }}>4.由于您将账号密码告知他人或末保管好自己的密码或与他人共享账号或任何其他非桃高乐的过错导致您的个人资料泄露；</p>

<p  style={{ fontWeight: 'bold' }}>5.由于与桃高乐链接或合作的其他网站所造成的的银行账户信息、身份信息泄露及由此而导致的任何法律争议和后果；</p>

<p  style={{ fontWeight: 'bold' }}>6.您(包括未成年人用户）向桃高乐提供错误、不完整、不实信想等，遭受任何其他损失；</p>

<p  style={{ fontWeight: 'bold' }}>7.如因系统维护或升级的需要而暂停服务时，我们将尽可能事先通知。对于服务或终端的终止而给您造成的任何损失，我们无需对您或任何第三方承担任何责任。</p>

{` (2) 您理解桃高乐对您的任何请求或行动要求均需要合理时间，在桃高乐响应您请求和行动时可能无法避免或阻止侵害后果的形成或扩大，除桃高乐存在法定过错外，桃高乐不承担责任。

退换货售后政策：
(1）修改地址：您可联系客服进行修改地址1次，不支持因错过修改地址而提出的取消订单和退款申请；
(2）模玩内手办商品类目，由于手办类物品为手工制作的定制类商品，因此可能存在轻微蹭色、溢色等涂装问题的瑕疵俗称官瑕，官瑕在手工定制类商品类目中为正常场景，将按据《消费者权益保护法》第二十五条第一款和《网络购买商品七日无理由退货暂行办法》第六条第一款执行，请您知悉并谨慎考虑后购买；
(3）如您收到的商品有质量问题，如存在损坏、少见或遗失，请您捉供有效凭证，证明您在签收时商品即存在上述问题，模玩将提供退换货服务并承担来回运费。
不同类型商品的售后政策：
一、手办/FIGMA/粘土人/盒蛋类商品
由于属于手工定作类商品，将依据《消费者权益保护法》第二十五条第一款和《网络购买商品七日无理由退货暂行办法》第六条第一款执行。
【售后范国】
断件/缺件/配件错漏/蹭色/涂装不全/严重盒损等非人为损坏。
【非售后范国】
1.个人安装问题损坏；
2.个人原因退货退款；
3.商品本身工艺会存在差异，普遍存在的细小瑕疵、分模线痕迹、色差、水纹等;
4.商品外包装可能因生产、制作、打包、物流运输等原因造成轻微磕碰、凹陷、商品外盒雪梨纸/牛皮纸/保护纸破损、胶贴翘起/气泡等；
5.上述情况属于正常现象，模玩不受理此类原因的售后。未按提要求举证致使举证不充分的、未在本规则规定的期限内发起申请等情况也无法受理，请您谅解。
【举证要求】
1.非模玩第二次包装商品：内部透明包装/吸塑式包装/透明包装袋的照片/视频或其他举证；
2.模玩二次包装商品：证明问题的照片/视频或其他举证。
【售后处理方式】
1.属于质量问题的，将购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续；
2. 部分商品属于品牌方提供售后，请按照模玩提供的联系方式进行售后申请，品牌方可提供售后范围为（部件换新/整件换新/修复)；
3.售后处理方式为部件换新/整件换新/修复，仅限模玩/品牌方无法提供上述售后服务时，由模玩为用户提供退货退款方案。
二、3C类商品
支持七天无理由退换货
【售后范围】
1.商品质量问题；
2.物流破损问题；
3.描述不符问题；
4.支持7天无理由退换货的商品。
【非售后范围】
1.手机、数码含授权或激活信息的，包括但不限于序列号、激活码、CDKEY等，一旦产生授权或激活程序，将依据《消费者权益保护法》第二十五条第三款和《网络购买商品七日无理由退货暂行办法》第六条第三款执行
2.若商品因使用产生商品清洁度、磨损度受损严重如加湿器使用后产生水渍问题等造成无法二次销售的;
3.其他因商品性质特殊且提前在页面告知您的。
【举证要求】
1.证明问题的服片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.对于存储类商品，请务必在返修前将里面的数据自行导出，否则若有数据遗失、损坏等模玩概不承担相应的贵任；
2.属于质量问题的，将说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，并寄回办理退换货手续；
3.如商品符合7天无理由退换货条件，需要在寄出前妥善包装，以免被委托的第三方快递运输损毁，影响退货。
三、家居用品
支持七天无理由退换货
【售后范围】
1.商品质量问题；
2.物流破损问题；
3.描述不符问题；
4.支持7天无理由退换货的商品。
【非售后范国】
商品被洗过、穿过、认为破坏或标牌拆除、影响二次销售的。
【举证要求】
1.证明问题的照片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.属于质量问题的，将说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续；
2.如商品符合7天无理由退换货条件，需要在寄出前妥善包装，以免被委托的第三方快递运输损毀，影响退货。
四、服饰类/箱包配饰/文具文体/毛绒玩具
支持七天无理由退换货
【售后范围】
1.商品质量问题：
2.物流破损问题；
3.描述不符问题；
4.支持7天无理由退换货的商品。
【非售后范围】
1.出于安全与卫生考虑，贴身用品如内衣裤、袜子、泳衣类商品，将依据《网络购买商品七日无理由退货暂行办法》第七条第一款执行。经权威部门检测商品存在质量问题的除外；
2.因个人原因造成的商品损坏(如自行修改尺寸，洗涤，刺绣，长时间穿着等）影响二次销售的；
3.商品及配件有由使用造成的磨损、损坏和痕迹的。
【举证要求】
1.证明问题的照片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.属于质量问题的，特说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续；
2.如商品符合7天无理由退换货条件，需要在寄出前妥善包装，以免被受托的第三方快递运输损毁，影响退货。
五、出版物
依据《消费者权益保护法》第二十五条第三款和《网络购买商品七日无理由退货暂行办法》第六条第三款、第四款执行。
【售后范围】
开封前商品包装破损、异常/腰封缺少/破损/排版有误/装订问题/缺少页数/错别字较多/本体破损/撞角严重。
【非售后范国】
1.包装含防份码的商品防伪码刮开后；
2.有序列号的商品，刮开使用后无质量问题的；
3.若商品存在因使用造成的商品受损，污染等情况的；
4.任何因非正常使用及保管导致商品出现质量问题的；
5.免费赠品；
6.定制期刊类商品、海外订购类、图书商品等。
【举证要求】
1.证明问题的照片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.退货时赠品需一并返回模玩，如赠品缺失，则商品无法全额退款（换货无需返回）；
2.属于质量问题的，将说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续。

桃高乐应用内的一切商业活动与Apple inc无关。如有任何玩法疑问的，可以发送电子邮件到service@taogao88.com邮箱或者在线客服咨询。`}
        </p>
      </div>
      <Footer />
    </>
  );
}

export default UseAfterSalesPolicy;
